import { render, staticRenderFns } from "./UpInfo.vue?vue&type=template&id=407cfb9a&scoped=true&"
import script from "./UpInfo.vue?vue&type=script&lang=js&"
export * from "./UpInfo.vue?vue&type=script&lang=js&"
import style0 from "./UpInfo.vue?vue&type=style&index=0&id=407cfb9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407cfb9a",
  null
  
)

export default component.exports